import React, { useContext, useState } from 'react';
import { rootContexts } from "../../contexts/rootContexts";
import EmailField from "../Form/EmailField";
import PasswordFiled from "../Form/PasswordField";
import SubmitField from "../Form/SubmitField";
import { Link } from "react-router-dom";
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
// import { loginService } from '../../services/authServices';
import * as yup from 'yup';
import { emailValidation, passwordValidation } from '../../utils/validation';
import { authLogin } from '../../services/authService';
import ForgotPassword from './ForgotPassword';
// import errorModel from '../Errors/ErrorModel';
export default function Login() {
    const [loader,setLoader]= useState(false);
    const [forgot,setForgot]= useState(false);
    const { setAsLogin } = useContext(rootContexts);
    const [serverError,setServerError]=useState("")
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
          email: "",
          password: "",
        },
        validationSchema:yup.object({
                 email:emailValidation,
                 password:passwordValidation,
        }),
        onSubmit: async (values) => {
            setLoader(true)
             const result = await authLogin(values)
            
            if(result.status===true){
            // errorModel('success',result.message)
            localStorage.setItem("token",result.token);
            localStorage.setItem("user",JSON.stringify(result.data));
            setLoader(false);
            setAsLogin(false)
            navigate('/');
            }
            else{
              setLoader(false);
              setServerError(result?.message)
           
              // errorModel('error',result.message)
              // setAsLogin(false)
            }

        },
      });
  return (
    <>
    
    <div className="mt-2 border-2 border-beta p-4 rounded">
                    <h1 className="h2 text-center">Login</h1>
                   
                    <form onSubmit={formik.handleSubmit} className="px-5 md:px-10">
                
                      <EmailField
                        label="Email"
                        name="email"
                        placeholder="Email"
                        formik={formik}
                       
                      />
                      <PasswordFiled
                        label="password"
                        name="password"
                        placeholder="password"
                        formik={formik}
                      />
                          {serverError ?
                    <div className="bg-orange-500/90 rounded-sm text-white text-center py-4 px-2">
                      {serverError}
                    </div> : null}
                      <div className=" py-2">
                        <SubmitField label="Sign in" loader={loader}/>
                        <span 
                         
                          onClick={()=>setForgot(true)}
                          className="font-imprima text-xs underline text-info cursor-pointer"
                        >
                       Forgot Password
                        </span>
                      </div>
                    </form>
                  </div>
                  <ForgotPassword forgot={forgot} setForgot={setForgot} />  
    </>
  )
}
